import DataType from 'scoreboard/datasets/model/data-type'
const { YES_NO } = DataType

/**
 * Ensure we have the correct value format for an alert subscription threshold value
 *
 * #45103 value should be "null" (a string) for a Yes/No scoring type, and
 * actually null for other types. This can get messed up when switching around
 * scoring types and alerts at the same time.
 */
function getCorrectSubscriptionValue(value, dataType, customTextScoringType) {
	let yesNoOrCustomText = dataType === YES_NO || customTextScoringType
	return yesNoOrCustomText && value == null ? 'null'
		: !yesNoOrCustomText && value == 'null' ? null
		: value
}

export { getCorrectSubscriptionValue }